export const URL_PARAM_KEYS = [
    "code",
    "finance_type",
    "offer_type",
    "contract_period",
    "contribution",
    "repurchase",
    "packages",
    "mileage",
];
export function readParamsFromUrl(search = window.location.search) {
    const params = new URLSearchParams(search);
    const result = {};
    for (const key of URL_PARAM_KEYS) {
        const value = params.get(key);
        if (value !== null && value !== "") {
            result[key] = value;
        }
    }
    return result;
}
export function buildSearchParamsFromConfig(config, code) {
    var _a;
    const params = { code };
    for (const field of config) {
        if (field.name === "packages" && field.value && typeof field.value === "object") {
            params.packages = Object.keys(field.value).join(",");
        }
        else if (["finance_type", "offer_type", "contract_period", "contribution", "repurchase", "mileage"].includes(field.name)) {
            params[field.name] = String((_a = field.value) !== null && _a !== void 0 ? _a : "");
        }
    }
    return params;
}
function buildNextUrl(params) {
    const url = new URL(window.location.href);
    for (const key of URL_PARAM_KEYS) {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
            url.searchParams.set(key, String(value));
        }
        else {
            url.searchParams.delete(key);
        }
    }
    return url;
}
function triggerAddressChange(url) {
    if (typeof window.$ !== "undefined") {
        window.$(document).trigger("address:change", [{ path: url.pathname, search: url.search }]);
    }
}
export function replaceUrlWithParams(params) {
    const url = buildNextUrl(params);
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
    triggerAddressChange(url);
}
export function pushUrlWithParams(params) {
    const url = buildNextUrl(params);
    window.history.pushState(null, "", url.pathname + url.search + url.hash);
    triggerAddressChange(url);
}
